import { Component, Input, OnInit, HostListener, ElementRef } from '@angular/core';
import { IAvisoDTO } from '../../../@core/backend/common/dto/aviso-dto';
import { AvisosService } from '../../../@core/backend/common/services/avisos.service';
import * as moment from 'moment';
import { EventEmitterService } from '../../../@core/backend/common/services/event.service';

@Component({
    selector: 'aviso-menu',
    styleUrls: ['./aviso-menu.component.scss'],
    templateUrl: './aviso-menu.component.html',
})
export class AvisoMenuComponent implements OnInit {

    hidden: boolean = true;

    avisos: IAvisoDTO[] = [];

    constructor(
        private eRef: ElementRef,
        private avisoService: AvisosService
    ) { }

    @HostListener('document:click', ['$event'])
    clickOut(event) {
        if(!this.eRef.nativeElement.contains(event.target)) {
            this.hidden = true;
        }
    }

    ngOnInit() {
        this.carregarAvisos();

        EventEmitterService.avisos().subscribe(() => {
            this.carregarAvisos();
        })
    }

    carregarAvisos(): void {
        this.avisoService.naoLidos(false).subscribe(data => this.avisos = data.Data);
    }

    marcarComoLido(event, aviso: IAvisoDTO): void {
        this.avisoService.marcarLida(aviso.Id).subscribe(() => this.carregarAvisos());
    }

    formatarData(data: string) {
        return moment(data).format("DD/MM HH:mm")
    }

    toggleWindow(event): void {
        this.hidden = !this.hidden;
    }
}